import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/ContentfulFields/Button';
import Backgrounder from 'components/Backgrounder';
import { withContent } from 'components/Content';

import styles from './styles.scss';

const CONTENT_KEYS = {
  title: 'Title',
  items: 'Items',
};

const Dispensers = ({ content }) => (
  <Backgrounder className={styles.dispensers}>
    <h2>{content.title}</h2>
    <ul>
      {content.items.fields.content.map((document) => (
        <li key={document.sys.id}>
          <img
            src={`${document.fields.image.fields.file.url}?fm=webp`}
            alt=""
          />
          <h3>{document.fields.title}</h3>
          <Button document={document.fields.button} className={styles.btn} />
        </li>
      ))}
    </ul>{' '}
  </Backgrounder>
);

Dispensers.propTypes = {
  content: PropTypes.object,
};

export default withContent(CONTENT_KEYS)(Dispensers);
